import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_APPLICATION_PHONE_NUMBER, CLIENT_RELATIONS_PHONE_NUMBER } from '../../constants';

@Component({
    selector: 'app-need-help',
    templateUrl: './need-help.component.html',
    styleUrls: ['./need-help.component.scss'],
    standalone: false
})
export class NeedHelpComponent implements OnInit {
  @Input() productType: 'KRON' | 'RemoteSigning' | 'Hybrid' | 'IPEN';

  public phone = DEFAULT_APPLICATION_PHONE_NUMBER;


  ngOnInit(): void {
    this.setPhoneNumber();
  }

  private setPhoneNumber(): void {
    switch (this.productType) {
      case 'Hybrid':
      case 'IPEN':
      case 'RemoteSigning':
        this.phone = CLIENT_RELATIONS_PHONE_NUMBER;
        break;
      case 'KRON':
      default:
        this.phone = DEFAULT_APPLICATION_PHONE_NUMBER;
        break;
    }
  }
}
